export default __webpack_public_path__ + "static/media/avatar-placeholder.22d7f1c8.png";